import { useCallback, useEffect, useRef, useState } from "react";

// Debounced autosave: status is idle|dirty|saving|saved|error|invalid; pending changes are saved on unmount too.
export const useAutosave = (data, save, delay = 1000) => {
  const [status, setStatus] = useState("idle");
  const json = JSON.stringify(data);
  const ref = useRef({ last: json, timer: null, pending: null, save });
  ref.current.save = save;

  const run = useCallback(async () => {
    const r = ref.current;
    clearTimeout(r.timer);
    if (r.pending === null) return;
    const payload = r.pending;
    r.pending = null;
    setStatus("saving");
    try { const ok = await r.save(JSON.parse(payload)); setStatus(ok === false ? "invalid" : "saved"); }
    catch { setStatus("error"); }
  }, []);

  useEffect(() => {
    const r = ref.current;
    if (json === r.last) return;
    r.last = json;
    r.pending = json;
    setStatus("dirty");
    clearTimeout(r.timer);
    r.timer = setTimeout(run, delay);
  }, [json, delay, run]);

  useEffect(() => () => {
    const r = ref.current;
    clearTimeout(r.timer);
    if (r.pending !== null) { const p = r.pending; r.pending = null; Promise.resolve(r.save(JSON.parse(p))).catch(() => {}); }
  }, []);
  return { status, flush: run };
};
